/**
 * The Performance PRO features a free-tier reader can be shown locked. The value travels to the
 * Engagement host with the upgrade request, which names the feature in the pop-up it opens, so the
 * same strings are declared on the host side: renaming one here must rename it there.
 */
export const PerformanceProFeature = {
    ManagerAssessment: 'managerAssessment',
    Competencies: 'competencies',
    CompetencyProfiles: 'competencyProfiles',
    VisionValues: 'visionValues',
    EmployeePortal: 'employeePortal',
    Meetings: 'meetings',
    Objectives: 'objectives',
    Reports: 'reports',
    PerformanceProfile: 'performanceProfile',
} as const;

export type PerformanceProFeatureValue =
    (typeof PerformanceProFeature)[keyof typeof PerformanceProFeature];
